import React from 'react';

function getServiceIcon(name) {
  const n = (name || '').toLowerCase();
  if (n.includes('legal')) return <path d="M12 3v18M5 6h14M7 6l-4 7h8L7 6Zm10 0-4 7h8l-4-7Z" />;
  if (n.includes('hr') || n.includes('man power'))
    return <path d="M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm8-1a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM2 21a6 6 0 0 1 12 0m3-8a5 5 0 0 1 5 5v3" />;
  return <path d="M4 19h16M6 17V8m6 9V5m6 12v-7M5 8h2m4-3h2m4 5h2" />;
}

export default function HomeServices({ bestServices, onGoTo, onServiceClick }) {
  return (
    <section className="section services" id="services" aria-labelledby="services-title">
      <div className="section-heading" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
        <p className="eyebrow dark" style={{ marginBottom: '8px' }}>What We Do</p>
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'flex-end', gap: '24px' }}>
          <h2 id="services-title" className="services-title-h2 dh-title-2" style={{ margin: 0 }}>
            Exclusive services for your business
          </h2>
          <a className="text-link" href="/service-listing" onClick={onGoTo('/service-listing')}>
            View all services
          </a>
        </div>
      </div>

      <div className="service-grid">
        {bestServices?.map((service) => (
          <article
            key={service._id}
            className="service-card"
            style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column' }}
            onClick={onServiceClick(service)}
          >
            <span className="icon-badge" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                {getServiceIcon(service.mainServiceName)}
              </svg>
            </span>

            <p className="service-count">{service.mainServiceName}</p>
            <h3 className="dh-title-3">{service.title}</h3>
            <p className="dh-text" style={{
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}>
              {(service.description || `${service.title} professional service provided by DALMAF.`)
                .replace(/<[^>]*>/g, '')}
            </p>

            <div className="service-tags">
              <span className="service-tag">{service.subServiceL1Name}</span>
              {service.subServiceL2Name && (
                <span className="service-tag">{service.subServiceL2Name}</span>
              )}
            </div>

            <a
              href={`/services/${service.mainServiceName?.toLowerCase()}/${service.slug || service.title?.toLowerCase().replace(/\s+/g, '-')}`}
              onClick={onServiceClick(service)}
              style={{ marginTop: 'auto', display: 'inline-block', paddingTop: '15px' }}
            >
              Learn More
            </a>
          </article>
        ))}
      </div>
    </section>
  );
}
